let video3 = document.querySelector("#video3");
let video6= document.querySelector("#box6-video-scroll-video");
let video3Replay = document.querySelector(".video3-replay");


let video3Play = 0;

video3Replay.addEventListener('click', ()=>{
  video3Replay.style.display = 'none'
  video3.play()
})
video3.addEventListener('ended', ()=>{
  video3Replay.style.display = 'flex'
})

// --------------------

let box2Content=document.querySelector(".box2-content")
let box2Scroll=document.querySelector(".box2-scroll")
let box2CanvasScroll= document.querySelector("#box2-canvas-scroll")

let box4Content=document.querySelector(".box4-content")
let box4Scroll=document.querySelector(".box4-scroll")
let box4CanvasScroll= document.querySelector("#box4-canvas-scroll")
// let box4CanvasScrollM= document.querySelector("#box4-canvas-scroll-m")

let box5Content=document.querySelector(".box5-content-box")
let box5Scroll=document.querySelector(".box5-scroll")

let box6ContentVideo=document.querySelector("#box6-video-scroll-video")

let box6Content=document.querySelector(".box6-video-content-box")
let box6Scroll=document.querySelector(".box6-video-scroll")

if (window.innerWidth <= 992 ) {
  box6ContentVideo.src = 'https://cdn.shopify.com/videos/c/o/v/cfae21afdd4d48b38fec307cd6f55fa9.mp4';
}else{
  box6ContentVideo.src = 'https://cdn.shopify.com/videos/c/o/v/bdf313a2e5e24749874d0246c9dc4c53.mp4';
}

const loader = new PxLoader()
const images = []
const images2 = []
// https://cdn.shopify.com/s/files/1/0604/6410/3654/files/K3_-800-10fps_00040.jpg?v=1686709030
// https://cdn.shopify.com/s/files/1/0606/1824/4315/files/K3_-800-10fps_061900033.jpg?v=1687169549
// https://cdn.shopify.com/s/files/1/0606/1824/4315/files/K3_-800-15fps_00042.jpg?v=1687170247

for (let i = 0; i < 92; i++) {
  images[i] = loader.addImage(`https://cdn.shopify.com/s/files/1/0604/6410/3654/files/K3_-800-10fps_${(i).toString().padStart(5, '0')}.png`)
  // images[i] = loader.addImage(`https://cdn.shopify.com/s/files/1/0606/1824/4315/files/K3_-800-15fps_${(i).toString().padStart(5, '0')}.jpg`)
}



if (window.innerWidth <= 1920 && window.innerWidth > 992) {
  // 可视宽度小于1920px的情况下执行的代码
  for (let i = 0; i < 16; i++) {
    // https://cdn.shopify.com/s/files/1/0604/6410/3654/files/Traveling_Light-10fps-1920_00015.png?v=1687832097
    images2[i] = loader.addImage(`https://cdn.shopify.com/s/files/1/0604/6410/3654/files/Traveling_Light-10fps-1920_${(i).toString().padStart(5, '0')}.png`)
    // images2[i] = loader.addImage(`https://cdn.shopify.com/s/files/1/0606/1824/4315/files/Traveling_Light-10fps-1920_800_${(i).toString().padStart(5, '0')}.png`)
  }
} else if(window.innerWidth <= 992){
  for (let i = 0; i < 16; i++) {
    // https://cdn.shopify.com/s/files/1/0604/6410/3654/files/Traveling_Light___0626__00015.png?v=1687831622
    images2[i] = loader.addImage(`https://cdn.shopify.com/s/files/1/0604/6410/3654/files/Traveling_Light___0626__${(i).toString().padStart(5, '0')}.png`)
  
  }
} else {
  // 可视宽度大于等于1920px的情况下执行的代码
  // https://cdn.shopify.com/s/files/1/0604/6410/3654/files/Traveling_Light-PC_0626__00033.png?v=1687831551
  for (let i = 0; i < 16; i++) {
    images2[i] = loader.addImage(`https://cdn.shopify.com/s/files/1/0604/6410/3654/files/Traveling_Light-PC_0626__${(i).toString().padStart(5, '0')}.png`)
  }
}


loader.addCompletionListener(function () {
  let context = box2CanvasScroll.getContext('2d')
  let context2 = box4CanvasScroll.getContext('2d')
  // let context3 = box4CanvasScrollM.getContext('2d')


  
  context.drawImage(images[0], 0, 0, 800, 800)
  if (window.innerWidth <= 992) {
    box4CanvasScroll.width = 750; 
    box4CanvasScroll.height = 700; 
    context2.clearRect(0, 0, box4CanvasScroll.width, box4CanvasScroll.height);
    context2.drawImage(images2[0], 0, 0, 750, 700)
  }else {
    box4CanvasScroll.width = 2560; 
    box4CanvasScroll.height = 1200; 
    context2.clearRect(0, 0, box4CanvasScroll.width, box4CanvasScroll.height);
    context2.drawImage(images2[0], 0, 0, 2560, 1200)
  }
  
})

loader.start()

window.addEventListener('scroll', ()=>{

  let scrolled = box2Scroll.offsetTop/(box2Content.clientHeight-box2Scroll.offsetHeight);
  let scrolled2 = box4Scroll.offsetTop/(box4Content.clientHeight-box4Scroll.offsetHeight);
  let scrolled3 = box5Scroll.offsetTop/(box5Content.clientHeight-box5Scroll.offsetHeight);
  let scrolled4 = box6Scroll.offsetTop/(box6Content.clientHeight-box6Scroll.offsetHeight);

 

  // let scrolled4 = box5Content.offsetTop - document.documentElement.scrollTop
  // console.log(scrolled4)
  let frame = Math.ceil(scrolled * 92)
  let frame2 = Math.ceil(scrolled2 * 16)
  // let frame3 = Math.ceil(scrolled4 * 40)
  changeFrame(frame)
  changeFrame2(frame2)
  changeFrame3(scrolled3)
  changeFrame4(scrolled4)

})

function changeFrame(frame) {
  let animationText1Box2=document.querySelector(".box2-scroll-text_1")
  let animationText2Box2=document.querySelector(".box2-scroll-text_2")
  let animationText3Box2=document.querySelector(".box2-scroll-text_3")

  // 92
  let index = frame - 1
  if (index < 0) index = 0

  if(index >= 10){
    animationText1Box2.classList.remove('animation-text-box2_out')
    animationText1Box2.classList.add('animation-text-box2')
  }else{
    animationText1Box2.classList.remove('animation-text-box2')
    animationText1Box2.classList.add('animation-text-box2_out')
  }

  if(index >= 30){
    animationText2Box2.classList.remove('animation-text-box2_out')
    animationText2Box2.classList.add('animation-text-box2')
  }else{
    animationText2Box2.classList.remove('animation-text-box2')
    animationText2Box2.classList.add('animation-text-box2_out')
  }

  if(index >= 50){
    animationText3Box2.classList.remove('animation-text-box2_out')
    animationText3Box2.classList.add('animation-text-box2')
  }else{
    animationText3Box2.classList.remove('animation-text-box2')
    animationText3Box2.classList.add('animation-text-box2_out')
  }
  
  let context = box2CanvasScroll.getContext('2d')


  if(typeof images[index] !== 'undefined'){
    context.drawImage(images[index], 0, 0, 800, 800)
  }
  
 
}

function changeFrame2(frame2) {
  let animationHeaderBox4=document.querySelector(".box4-header")
  let animationText1Box4=document.querySelector(".box4-scroll-text")
  // let animationText2Box4=document.querySelector(".box4-scroll-text2")
  // 41
  let index = frame2 - 1
  if (index < 0) index = 0

  if(index > 1){
    animationHeaderBox4.classList.add('animation-text-box4_out')
  }else{
    animationHeaderBox4.classList.remove('animation-text-box4_out')
  }

  if(index >= 3 && index < 10){
    animationText1Box4.classList.remove('animation-text-box4_out')
    animationText1Box4.classList.add('animation-text-box4')
  }else if(index >= 24){
    animationText1Box4.classList.remove('animation-text-box4')
    animationText1Box4.classList.add('animation-text-box4_out')
  }

  // if(index >= 30){
  //   animationText2Box4.classList.remove('animation-text-box4_out')
  //   animationText2Box4.classList.add('animation-text-box4')
  // }else{
  //   animationText2Box4.classList.remove('animation-text-box4')
  //   animationText2Box4.classList.add('animation-text-box4_out')
  // }

  let context2 = box4CanvasScroll.getContext('2d')
  // let context3 = box4CanvasScrollM.getContext('2d')
  if (window.innerWidth <= 992) {
    if(typeof images[index] !== 'undefined'){
      box4CanvasScroll.width = 750; 
      box4CanvasScroll.height = 700; 
      context2.clearRect(0, 0, box4CanvasScroll.width, box4CanvasScroll.height);
      context2.drawImage(images2[index], 0, 0, 750, 700)
    }
  }else {
    if(typeof images[index] !== 'undefined'){
      box4CanvasScroll.width = 2560; 
      box4CanvasScroll.height = 1200; 
      context2.clearRect(0, 0, box4CanvasScroll.width, box4CanvasScroll.height);
      context2.drawImage(images2[index], 0, 0, 2560, 1200)
    }
  }
}

function changeFrame3(scrolled3){
  let animationText1Box5=document.querySelector(".box5-header")
  let animationText2Box5=document.querySelector(".ppi-box")
  let animationImgBox5=document.querySelector(".box5-content-img")

  let ppiItemLine1=document.querySelector(".ppi-item-line1")
  let ppiItemLine2=document.querySelector(".ppi-item-line2")
  
  // let index = frame3 - 1
  // if (index < 0) index = 0
  // 40
  // console.log(scrolled3)

  if (window.innerWidth > 500) {
    if (scrolled3 <= 0.2) {
      animationText1Box5.style.opacity = (0.5 - scrolled3) / 0.1
      // animationText1Box5.style.marginTop = scrolled3 * 1000 * -1 + 'px'
    } else {
      animationText1Box5.style.opacity = 0
    }
  }
  

  if (scrolled3 > 0.4) {
    animationText2Box5.style.opacity = (scrolled3 - 0.1) / 0.1
    ppiItemLine1.classList.add('fade-in')
    ppiItemLine2.classList.add('fade-in')
  }else{
    animationText2Box5.style.opacity = 0
    ppiItemLine1.classList.remove('fade-in')
    ppiItemLine2.classList.remove('fade-in')
  }

  // if(index == 1 ){
    
  //   animationText1Box5.classList.add('animation-fade-in2')
  //   // setTimeout(function() {
  //   //   // 在延迟时间后执行的代码
  //   //   box6Show1.classList.add('animation-fade-in2')
  //   //   box6Show2.classList.add('animation-fade-in2')
  //   //   box6Show3.classList.add('animation-fade-in2')
  //   // }, 800);
  // }

  // if(index <= 1 ){
  //   animationImgBox5.classList.add('animation-fade-in2')
  // }else{
  //   animationImgBox5.classList.remove('animation-fade-in2')
  // }

  // if(index <= 20 ){
  //   animationText1Box5.classList.remove('animation-fade-in2')
  // }

  // if(index <= 30 ){
  //   animationText2Box5.classList.add('animation-fade-in2')
  // }else{
  //   animationText2Box5.classList.remove('animation-fade-in2')
  // }

}

function changeFrame4(scrolled4){

  let animationWowVideo=document.querySelector(".box6-video-wow-box")
  let wow=document.querySelector("#wow")
  // let animationTextWowVideo=document.querySelector(".box6-video-wow-text")
  animationWowVideo.style.width = animationWowVideo.style.height = document.documentElement.clientWidth * 20 * (scrolled4 * scrolled4 * scrolled4) + 'px'
  // let tt =  document.documentElement.clientWidth * 10 * (scrolled4 * scrolled4 * scrolled4)
  // animationTextWowVideo.style.fontSize = 400 + tt+'px'
  // console.log(tt)
  if (scrolled4 <= 0.1) {
    
    // animationText1Box5.style.marginTop = scrolled3 * 1000 * -1 + 'px'
  }

  if (scrolled4 >= 0.4) {
    // $A13TextBg.style.opacity = (1 - scrolled) / 0.5
    animationWowVideo.classList.add('transparent')
  } else {
    // $A13TextBg.style.opacity = 1
    animationWowVideo.classList.remove('transparent')
  }

  if (scrolled4 >= 0.7) {
    animationWowVideo.style.opacity = (1 - scrolled4)
  } else {
    animationWowVideo.style.opacity = 1
  }

  if (scrolled4 >= 0.9) {
    animationWowVideo.style.display = 'none'
    animationWowVideo.style.opacity = 0
  }else{
    animationWowVideo.style.display = 'block'
  }

}



new Splide( '#box7-splide', {
  type   : 'loop',
  drag   : 'free',
  focus  : 'center',
  arrows: false, // 取消箭头
  perPage: 2,
  autoScroll: false,
  breakpoints: {
    992: {
        perPage: 1
    },
  },
} ).mount();

new Splide( '#box9-splide-left', {
  type   : 'loop',
  drag   : 'free',
  focus  : 'center',
  arrows: false, // 取消箭头
  pagination: false, // 取消下标
  perPage: 5,
  breakpoints: {
    992: {
        perPage: 4
    },
    750: {
      perPage: 2
    }
  },
  autoScroll: {
    speed: 0.5,
    pauseOnHover: false,
  }
  
} ).mount( window.splide.Extensions );

new Splide( '#box9-splide-right', {
  type   : 'loop',
  drag   : 'free',
  focus  : 'center',
  arrows: false, // 取消箭头
  pagination: false, // 取消下标
  perPage: 5,
  breakpoints: {
    992: {
        perPage: 4
    },
    750: {
      perPage: 2
    }
  },
  autoScroll: {
    speed: -0.5,
    pauseOnHover: false
  }
  
} ).mount( window.splide.Extensions );



